import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  /** Accessible label for the loading state. Defaults to "Loading..." */
  label?: string;
}

const sizeClasses = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
  xl: "h-12 w-12",
};

export function LoadingSpinner({
  size = "md",
  className,
  label = "Loading...",
}: LoadingSpinnerProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn("flex items-center justify-center", className)}
    >
      <span className="sr-only">{label}</span>
      <div
        className={cn(
          "animate-spin rounded-full border-2 border-gray-300 dark:border-gray-700 border-t-blue-600",
          sizeClasses[size]
        )}
        aria-hidden="true"
      />
    </div>
  );
}
